import React from 'react';
import UserList from "../containers/UserList/UserList";

const UserListPage: React.FC = () => {
  return (<UserList />);
};

export default UserListPage;
